import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=60ae2780&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae2780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ae2780')) {
      api.createRecord('60ae2780', component.options)
    } else {
      api.reload('60ae2780', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=60ae2780&scoped=true&", function () {
      api.rerender('60ae2780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-48JmpZ7RNFEFK/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports